import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import { ExpandMore } from '@mui/icons-material';
import { DefaultBlot, EllipseImage, LightEllipse } from 'src/assets';
import './marketFaq.scss';
import { Faq } from 'src/assets/pages/marketFaq';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const MarketFaq = () => {
  const { t } = useTranslation();

  const renderAccordion = useCallback(() => {
    return (
      <Accordion className="accordion" disableGutters>
        <AccordionSummary className="accordion-summary" expandIcon={<ExpandMore />}>
          <h3>Question</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-details">
          <text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet,
            consectetur Lorem ipsum dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit
            amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur Lorem ipsum
            dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur
            adipiscing elitLorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet,
            consectetur adipiscing elit
          </text>
        </AccordionDetails>
      </Accordion>
    );
  }, []);

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="market-faq">
      <div className={`market-faq-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="market-faq-supertitle">
          <supertitle>{t('marketFaq:supertitle')}</supertitle>
        </div>
        <div className="market-faq-box">
          <img src={Faq} alt={Faq} className="market-faq-box-image" />
          <div className="market-faq-section">
            <h1>{t('marketFaq:title')}</h1>
            {renderAccordion()}
            {renderAccordion()}
            {renderAccordion()}
            {renderAccordion()}
          </div>
        </div>

        <img src={EllipseImage} alt={EllipseImage} className="market-faq-image-1" />
        <img src={EllipseImage} alt={EllipseImage} className="market-faq-image-2" />
        <img src={LightEllipse} alt={LightEllipse} className="market-faq-image-3" />
        <img src={DefaultBlot} alt={DefaultBlot} className="market-faq-image-4" />
      </div>
    </div>
  );
};
